import axios from 'axios';

const TOKEN_URL = process.env.REACT_APP_API_URL + "api/app/token/token";
const CLIENT_ID = process.env.REACT_APP_TOKEN_CLIENT_ID || "";
const CLIENT_SECRET = process.env.REACT_APP_TOKEN_CLIENT_SECRET || "";
const SUBSCRIPTION_KEY = process.env.REACT_APP_API_SUBSCRIPTION_KEY || "";
let cachedToken: string | null = null;
let tokenPromise: Promise<string> | null = null;

async function fetchToken(): Promise<string> {
    const response = await axios.post(TOKEN_URL, {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET
    }, {
        headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY
        }
    });

    const token = response.data?.response?.access_token ?? response.data?.access_token ?? response.data?.token ?? (typeof response.data === 'string' ? response.data : null);

    if (!token || typeof token !== 'string') {
        throw new Error(`[TokenService] Token inválido recibido: ${JSON.stringify(response.data)}`);
    }

    return token;
}

export async function getToken(): Promise<string> {
    if (cachedToken) {
        return cachedToken;
    }

    if (tokenPromise) {
        return tokenPromise;
    }

    tokenPromise = fetchToken()
        .then(token => {
            cachedToken = token;
            tokenPromise = null;
            return token;
        })
        .catch(err => {
            tokenPromise = null;
            throw err;
        });

    return tokenPromise;
}

export function clearToken(): void {
    cachedToken = null;
    tokenPromise = null;
}
